import styles from '@styles/components/mobile/Header.module.css';
import { Spin as Hamburger } from 'hamburger-react';



const Header = ({hamburgerOpen, onHamburgerClick}) => {
    return (
        <>
        <div className={styles.header}>
            <Hamburger color="#667085" rounded toggled={hamburgerOpen} toggle={onHamburgerClick} />
            <div className={styles['logo-container']}>
                <img className={styles['logo']} alt='logo'/>
            </div>
        </div>

        <div className={styles['header-stand-in']}/>
        </>
    );
}

export default Header;